// extracted by mini-css-extract-plugin
module.exports = {"arrowLink":"arrow-link_arrowLink__HJ4Pa","left":"arrow-link_left__T4Ix5","right":"arrow-link_right__J5mp8"};